import { CauseSubscription, useShowBackerConsumerCauseSubscriptions } from '@givebacks/api/backer';
import { CauseLogo, ClickableOptionsCard } from 'core/Components';
import { toTitleCase } from 'core/Utils';
import { Modal, Text, dotSeparator } from 'ui';

import { CauseStatusModal } from './CauseStatusModal';
import {
  CommunicationListsModalProvider,
  useCommunicationListsModalProvider,
} from './CommunicationListsProvider';
import { UnfollowCauseModal } from './UnfollowCauseModal';
import { UnsubscribeFromCauseModal } from './UnsubscribeFromCause';

const CommunicationListsActionIcon = ({ title }: { title?: string }) => {
  const { openModalById } = useCommunicationListsModalProvider({});

  return (
    <ClickableOptionsCard.Row
      title={title ?? 'Manage Communication Lists'}
      onClick={() => openModalById('CommunicationLists')}
    />
  );
};

const createCommunicationListsSubtitle = (subscription: CauseSubscription) => {
  const subscriptionsClosed =
    subscription.communication_status === 'unsubscribed' && !subscription.site_joins_enabled;

  const selectionStatus = subscription.selected ? 'Following' : 'Not Following';

  const notSubscribed =
    !subscription.communication_status || subscription.communication_status === 'pending';

  const communicationStatus = subscriptionsClosed
    ? 'Subscriptions Closed'
    : toTitleCase(notSubscribed ? 'Not subscribed' : subscription.communication_status);

  return (
    <Text fz="xxxs" c="gray">
      {selectionStatus}
      {dotSeparator}
      <Text fz="xxxs" span c={subscriptionsClosed ? 'cerise' : 'gray'}>
        {communicationStatus}
      </Text>
    </Text>
  );
};

const CommunicationListsModalContent = () => {
  const { data: causeSubscriptions } = useShowBackerConsumerCauseSubscriptions();
  const { setMeta, openNextStep } = useCommunicationListsModalProvider({
    id: 'CommunicationLists',
  });

  return (
    <ClickableOptionsCard>
      {causeSubscriptions?.map((subscription) => (
        <ClickableOptionsCard.Row
          key={subscription.uuid}
          title={subscription.name}
          subtitle={createCommunicationListsSubtitle(subscription)}
          leftSection={<CauseLogo cause_uuid={subscription.uuid} size="sm" />}
          onClick={() => {
            setMeta({ causeId: subscription.uuid });
            openNextStep();
          }}
        />
      ))}
    </ClickableOptionsCard>
  );
};
const CommunicationListsModal = ({ title }: { title?: string }) => {
  const { opened, close } = useCommunicationListsModalProvider({ id: 'CommunicationLists' });

  return (
    <Modal opened={opened} title={title ?? 'Manage Communication Lists'} onClose={close}>
      <CommunicationListsModalContent />
    </Modal>
  );
};

const CommunicationListsModalGroup = ({
  title,
  causeStatusModalTitle,
}: {
  title?: string;
  causeStatusModalTitle?: string;
}) => {
  return (
    <CommunicationListsModalProvider meta={{}}>
      <CommunicationListsActionIcon title={title} />
      <CommunicationListsModal title={title} />
      <CauseStatusModal title={causeStatusModalTitle} />
      <UnsubscribeFromCauseModal />
      <UnfollowCauseModal />
    </CommunicationListsModalProvider>
  );
};

export { CommunicationListsModalGroup };
